var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 310,
    viewBox: "0 0 501 310",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.249 .25)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FF5F00",
    x: 182.402,
    y: 33.038,
    width: 135.202,
    height: 242.962
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.987457,154.519204 C190.944172,107.107486 212.707207,62.3098127 250.003856,33.038106 C186.652584,-16.7575198 95.6707044,-9.50995217 41.0017304,49.6871031 C-13.6672435,108.884158 -13.6672435,200.15425 41.0017304,259.351305 C95.6707044,318.548361 186.652584,325.795928 250.003856,276.000302 C212.707463,246.728389 190.944493,201.930848 190.987457,154.519204 Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,154.519204 C500,213.676187 466.227529,267.641691 413.019891,293.496979 C359.812253,319.352267 296.512618,312.558253 250.003856,276.000302 C287.265692,246.700568 309.019834,201.92088 309.019834,154.519204 C309.019834,107.117529 287.265692,62.3378404 250.003856,33.038106 C296.512618,-3.51984474 359.812253,-10.313859 413.019891,15.541429 C466.227529,41.3967171 500,95.3622209 500,154.519204 L500,154.519204 Z",
    fill: "#F79E1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.42bd05530b16b1295c85fe0bf18f2525.svg";
export { ForwardRef as ReactComponent };